import { InputVariant } from "@/contexts/PageContext/lib/theming/variants";
import { FormFieldAttributes } from "@/types/landing";
import { ChangeEventHandler } from "react";

export type InputProps = {
    variant: InputVariant;
    attributes: FormFieldAttributes;
    onChange: ChangeEventHandler<HTMLInputElement> | undefined;
    lastInputIndex: number;
    bqMapping: string;
    styles: { readonly [key: string]: string };
    isInPopupAndNotBannerflow: boolean;
    index: number;
};

export const Input = ({
    attributes,
    lastInputIndex,
    onChange,
    bqMapping,
    styles,
    isInPopupAndNotBannerflow,
    index,
    variant,
}: InputProps) => {
    return (
        <input
            className={[
                styles.input,
                index === lastInputIndex ? styles.lastInput : "",
                isInPopupAndNotBannerflow
                    ? styles.inPopupNotBannerflowInput
                    : "",
            ].join(" ")}
            name={bqMapping}
            autoComplete={attributes?.autoComplete}
            type={attributes?.fieldType}
            placeholder={attributes?.placeholder}
            required={attributes?.isRequired}
            pattern={
                // Optional country code at the beginning (with a plus sign and 1-3 digits).
                // Optional space after the country code.
                // 3-4 for the area code.
                // Optional space after the area code.
                // 3-4 digits for the first block of numbers.
                // Optional space after the first block of numbers.
                // 3 for the second block of numbers.
                attributes.fieldType === "tel"
                    ? "^(?:\\+\\d{1,3})?\\s?\\d{3,4}\\s?\\d{3,4}\\s?\\d{3}$"
                    : undefined
            }
            onChange={onChange}
        />
    );
};
